export const CORE = 'core';
export const CORE_TOGGLE_SIDEBAR = 'CORE_TOGGLE_SIDEBAR';
export const CORE_TOGGLE_NOTIFICATION = 'CORE_TOGGLE_NOTIFICATION';
export const CORE_HIDE_NOTIFICATION = 'CORE_TOGGLE_NOTIFICATION';
export const CORE_ADD_NOTIFICATION = 'CORE_ADD_NOTIFICATION';
export const CORE_BREADCRUMBS_SET = 'CORE_BREADCRUMBS_SET';
export const CORE_BREADCRUMBS_PUSH = 'CORE_BREADCRUMBS_PUSH';
export const CORE_BREADCRUMBS_POP = 'CORE_BREADCRUMBS_POP';
export const CORE_BREADCRUMBS_REPLACE = 'CORE_BREADCRUMBS_REPLACE';
export const CORE_BREADCRUMBS_EMPTY = 'CORE_BREADCRUMBS_EMPTY';
export const CORE_COUNTRIES = 'CORE_COUNTRIES';
export const CORE_STATE_PROVINCE = 'CORE_STATE_PROVINCE';
export const CORE_WAREHOUSES = 'CORE_WAREHOUSES';
export const CORE_LANGUAGES = 'CORE_LANGUAGES';
export const CORE_CURRENCIES = 'CORE_CURRENCIES';
export const CORE_STORES = 'CORE_STORES';
export const CORE_STORE = 'CORE_STORE';
export const CORE_CONFIG = 'CORE_CONFIG';
export const CORE_IS_LOADING = 'CORE_IS_LOADING';
